<template>
  <div>
    <div class="box" id="box" ref="box">
      <h1>新型重大安全风险通报情况</h1>

      <div class="big">
        <!-- 橙色洞-->
        <div class="dong1">

          <div class="find">
            <h2>{{ data.discover }}</h2>
            <p>新发现</p>
          </div>

          <img src="../../assets/PlatformOverview/hole-1.png" alt="">
        </div>

        <!-- 紫色洞-->
        <div class="dong2">

          <div class="find2">
            <h2>{{ data.disclose }}</h2>
            <p>通报数量</p>
          </div>

          <img src="../../assets/PlatformOverview/hole-2.png" alt="">
        </div>

        <!-- 绿色洞 -->
        <div class="dong3">

          <div class="find3">
            <h2>{{ data.fix }}</h2>
            <p>修复数量</p>
          </div>

          <img src="../../assets/PlatformOverview/hole-3.png" alt="">
        </div>
        <!-- 射线 -->
        <div class="shexian">
          <div class="ray-container1">
            <div class="ray1">
              <img src="../../assets/PlatformOverview/ray-1.png" alt="">
            </div>
          </div>
          <div class="ray-container">
            <div class="ray">
              <img src="../../assets/PlatformOverview/ray-2.png" alt="">
            </div>
          </div>
          <div class="ray-container3">
            <div class="ray3">
              <img src="../../assets/PlatformOverview/ray-3.png" alt="">
            </div>
          </div>
        </div>
        <!--小球-->
        <div class="ball-container">
          <transition-group name="ball">
            <!-- 使用transition-group来包裹小球，实现多个小球的动画效果 -->
            <div v-for="(ball, index) in balls" :key="index" class="ball" ref="ball"
                 :style="{ left: ball.left + 'px', bottom: ball.bottom + 'px', width: ball.size + 'px', height: ball.size + 'px' }">
              <!-- 小球的样式和位置随机生成 -->
            </div>
          </transition-group>
        </div>
        <!--小球-->
        <div class="ball-container2">
          <transition-group name="ball2">
            <!-- 使用transition-group来包裹小球，实现多个小球的动画效果 -->
            <div v-for="(ball2, index) in balls" :key="index" class="ball2" ref="ball2"
                 :style="{ left: ball2.left + 'px', bottom: ball2.bottom + 'px', width: ball2.size + 'px', height: ball2.size + 'px' }">
              <!-- 小球的样式和位置随机生成 -->
            </div>
          </transition-group>
        </div>
        <!--小球-->
        <div class="ball-container3">
          <transition-group name="ball3">
            <!-- 使用transition-group来包裹小球，实现多个小球的动画效果 -->
            <div v-for="(ball3, index) in balls" :key="index" class="ball3" ref="ball3"
                 :style="{ left: ball3.left + 'px', bottom: ball3.bottom + 'px', width: ball3.size + 'px', height: ball3.size + 'px' }">
              <!-- 小球的样式和位置随机生成 -->
            </div>
          </transition-group>
        </div>

        <!--    光圈背景    -->
        <div class="img">
          <img src="../../assets/PlatformOverview/aperture.png" alt="">
        </div>
        <!--    光晕    -->
        <div class="lightImg">
          <img src="../../assets/PlatformOverview/lighting.png" alt="">
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {getVulnerabilityReporting} from "@/service/dashboard";

export default {
  data() {
    return {
      data:{
        discover:"233",
        disclose:"455",
        fix:"123"
      },
      balls: [], // 存储生成的小球信息
      balls2: [], // 存储生成的小球信息
      balls3: [] // 存储生成的小球信息
    };
  },
  mounted() {
    this.getData();
    // 在组件挂载后开始生成小球
    this.generateBalls();
    this.generateBalls2();
    this.generateBalls3();
  },
  methods: {
    getData(){
      getVulnerabilityReporting().then(res => {
        this.data = res;
      });
    },
    generateBalls() {
      // 定时生成小球
      setInterval(() => {
        const size = Math.floor(Math.random() * 3)+2 ; // 随机生成小球大小
        const left = Math.random() * (this.$el.clientWidth - size); // 随机生成小球横坐标
        const bottom = 0; // 小球初始纵坐标在底部
        const duration = Math.random() * 3000 + 5000; // 随机生成小球运动持续时间

        this.balls.push({ size, left, bottom });

        setTimeout(() => {
          this.balls.splice(0, 1);
        }, 1400);
      }, 300); // 每隔一段时间生成一个小球
    },
    generateBalls2() {
      // 定时生成小球
      setInterval(() => {
        const size = Math.floor(Math.random() * 3)+2 ; // 随机生成小球大小
        const left = Math.random() * (this.$el.clientWidth - size); // 随机生成小球横坐标
        const bottom = 0; // 小球初始纵坐标在底部
        const duration = Math.random() * 3000 + 5000; // 随机生成小球运动持续时间

        this.balls2.push({ size, left, bottom });

        setTimeout(() => {
          this.balls2.splice(0, 1);
        }, 1450);
      }, 450); // 每隔一段时间生成一个小球
    },
    generateBalls3() {
      // 定时生成小球
      setInterval(() => {
        const size = Math.floor(Math.random() * 3)+2 ; // 随机生成小球大小
        const left = Math.random() * (this.$el.clientWidth - size); // 随机生成小球横坐标
        const bottom = 0; // 小球初始纵坐标在底部
        const duration = Math.random() * 3000 + 5000; // 随机生成小球运动持续时间

        this.balls3.push({ size, left, bottom });

        setTimeout(() => {
          this.balls3.splice(0, 1);
        }, 1300);
      }, 350); // 每隔一段时间生成一个小球
    }
  }
};


</script>
<style scoped lang="less">
*{
  margin: 0;
  padding: 0;
}
.box {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 430px;
  height: 342px;
  border-radius:10px ;
  color: rgba(255, 255, 255, 1);
  .lightImg{
    position: absolute;
    left: 10%;
    top: -30%;
  }
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  position: absolute;
  left: 36px;
  top: 15px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
}
.big{
  position: relative;
  left:13px;
  bottom: -84px;
}
.dong1{
  width: 118px;
  position: absolute;
  bottom: 48px;
  left: 74px;
}
.find{
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%,-50%);
}
.find2{
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%,-50%);
}
.find3{
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%,-50%);
}
h2{
  font-family: 'YouSheBiaoTiHei';
  font-size: 33px;
  height: 43px;
  line-height: 43px;
}
p{
  font-size: 12px;
}
.dong2{
  width: 167px;
  position: absolute;
  bottom: 57px;
  left: 153px;
}
.dong3{
  width: 88px;
  position: absolute;
  bottom: 57px;
  left: 251px;
}
.shexian{
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;

}
.ray-container {
  position: relative;
  width: 100%;
  height: 100px;
}
.ray-container1,.ray-container3{
  position: relative;
  width: 100%;
  height: 50px;
}
.ray {
  position: absolute;
  left: 36%;
  bottom: 68px;
  animation:play 1s infinite;
}
.ray1 {
  position: absolute;
  right: -17%;
  bottom: 10px;
  animation:play1 1s infinite;
}
.ray3 {
  position: absolute;
  left:-40px;
  bottom: 48px;
  animation:play3 1s infinite;
}
.img{
  width: 404px;
}
img{
  width: 100%;
}

@keyframes play {
  0% {
    bottom: 88px;
    opacity: 1;
    height: 0;
  }
  100% {
    bottom: 70%;
    height: 50px;
    opacity: 0;
  }
}
@keyframes play1 {
  0% {
    bottom: -15px;
    opacity: 1;
    height: 0;
  }
  100% {
    bottom: 10%;
    height: 10px;
    opacity: 0;
  }
}
@keyframes play3{
  0% {
    bottom: -20px;
    opacity: 1;
    height: 0;
  }
  100% {
    bottom: 10%;
    height:1px;
    opacity: 0;
  }
}

.ball-container {
  position: absolute;
  left: 19%;
  top: 25%;
  width: 100px;
  height: 110px; /* 盒子的高度 */
  overflow: hidden;
  //background-color: rgba(2,2,2,0.4);
}

.ball {
  position: absolute;
  background-color: rgba(245, 165, 71, 0.8);
  border-radius: 50%; /* 小球圆形 */
  animation: rise 2s infinite linear; /* 小球上升动画 */
}
.ball-container2 {
  position: absolute;
  left: 42%;
  top:1%;
  width: 110px;
  height: 160px; /* 盒子的高度 */
  overflow: hidden;
  //background-color: rgba(2,2,2,0.4);
}

.ball2 {
  position: absolute;
  background-color: rgba(170, 184, 255, 0.8);
  border-radius: 50%; /* 小球圆形 */
  animation: rise 2.5s infinite linear; /* 小球上升动画 */
}
.ball-container3 {
  position: absolute;
  left: 62%;
  top:35%;
  width: 70px;
  height: 90px; /* 盒子的高度 */
  overflow: hidden;
  //background-color: rgba(2,2,2,0.4);
}

.ball3 {
  position: absolute;
  background-color: rgba(170, 253, 255, 0.8);
  border-radius: 50%; /* 小球圆形 */
  animation: rise 2s infinite linear; /* 小球上升动画 */
}

@keyframes rise {
  0% {
    top:100%;
    opacity: 1;
  }
  75% {
    top:55%;
    opacity: 0.6;
  }
  100% {
    top:15%;
    opacity: 0;
  }
}
</style>